export enum StepsForgotPassword {
    ONE = 1,
    TWO = 2,
    THREE = 3,
}